export default "__VITE_ASSET__BLid_eO5__"